///
/// EarthBrowser
///
/// Migration v10 to v11: Add GeoPackage visibility state
///
/// Created by Matt Giger on 12/15/2024
/// Copyright (c) 2024 Geodata Labs
///

interface StateV10 {
	earthbrowser?: Record<string, unknown>
}

/**
 * Migration from version 10 to 11: Add GeoPackage state fields
 * - Adds geopackageLayerVisibility field (empty object)
 * - Adds geopackageDatasetVisible field (empty object)
 */
export function migrateV10toV11(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV10

	// Return new state with GeoPackage fields added
	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			geopackageLayerVisibility: {},
			geopackageDatasetVisible: {}
		}
	}
}
